import { StateMapDisk } from '../state/state_map_disk.enum'
import { gameDisk, mapDisk, lobbyDisk, replayDisk } from './IndexedDBDisk'
import { backendAxios } from '../../../axios'
import { StateRowValue } from '../../../backend.d'
import type { State } from '../state/State.type'

export async function saveToDisk(state: State, diskType: StateMapDisk): Promise<StateRowValue> {
  if (diskType === StateMapDisk.IndexedDB) {
    const type = state.type === 1 ? mapDisk : state.type === 2 ? gameDisk : state.type === 3 ? lobbyDisk : replayDisk
    return await type.save(state)
  } else if (diskType === StateMapDisk.Cloud) {
    const endpoint = state.type === 1 ? '/st1/map' : state.type === 2 ? '/st1/game' : state.type === 3 ? '/st1/lobby' : '/st1/replay'
    const id = state.map.id
    const response = id
        ? await backendAxios.post(`${endpoint}/${id}`, { data: state })
        : await backendAxios.post(endpoint, { state })
    return response.data
  }
  throw new Error('Unsupported disk type')
}
